// Interfaces.
import { LocatorInterface } from '../interfaces/locator.interface'


export class Metadata {
  constructor(
    public totalItems: number
  ) { }
}

export class DataContainer<T> {

  protected _id: string;
  protected _rev: string;
  protected locator: LocatorInterface
  protected payload: T[];
  protected maxAge: number;
  protected timestamp: number;
  protected expires: number = 0;
  protected emptyDoc: boolean;
  protected metadata: Metadata;


  public constructor(locator: LocatorInterface, payload: T[], metadata: Metadata, maxAge: number) {
    this.setPayload(payload);
    this.setLocator(locator);
    this.setMaxAge(maxAge);
    this.updateExpire(null);
    this.metadata = metadata;
  }

  public static getNowSeconds() {
    return Date.now() / 1000 | 0;
  }

  public setTimestamp(timestamp: number) {
    this.timestamp = timestamp;
  }

  public setPayload(payload: T[]) {
    this.setTimestamp(DataContainer.getNowSeconds());
    this.payload = payload;
    this.emptyDoc = payload === null;;
  }

  public getPayload(): T[] {
    return this.payload;
  }

  public setLocator(locator: LocatorInterface) {
    this.locator = locator;
    this.updateId();
  }

  public getLocator(): LocatorInterface {
    return this.locator;
  }

  public setMaxAge(maxAge) {
    this.maxAge = maxAge;
  }

  public updateExpire(expires) {
    this.expires = expires !== null ? expires : this.timestamp + this.maxAge;
  }

  public setRevision(rev: string) {
    this._rev = rev;
  }

  public getRevision(): string {
    return this._rev;
  }

  public get expired(): boolean {
    let now = DataContainer.getNowSeconds();
    return this.expires < now;
  }

  public get totalItems(): number {
    return this.metadata.totalItems;
  }

  public get availableItems(): number {
    return this.payload.length;
  }

  /**
   * Indicates if document is empty, but NOT if payload is empty.
   *
   * Document can be not empty and payload can be empty array (an empty array,
   * no results).
   *
   * If document is empty means there's no data for that locator.
   *
   */
  public get empty(): boolean {
    return this.emptyDoc;
  }

  /**
   * Indicates if document represents a erroneous data.
   *
   * Usually this means data should requested again.
   */
  public get erroneous(): boolean {
    return false;
  }

  protected updateId() {
    this._id = this.locator.getId();
  }
}